import { render, staticRenderFns } from "./deal-list.vue?vue&type=template&id=7c508c58&"
import script from "./deal-list.vue?vue&type=script&lang=js&"
export * from "./deal-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports